import React, { createContext, useContext, useState, useCallback } from "react";
import ContactFormModal from "@/components/site/ContactFormModal";

const ContactModalContext = createContext({ open: () => {} });

export const useContactModal = () => useContext(ContactModalContext);

export const ContactModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <ContactModalContext.Provider value={{ open, close }}>
      {children}
      <ContactFormModal open={isOpen} onClose={close} />
    </ContactModalContext.Provider>
  );
};
